import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku, KoteishisanType } from '@/repositories/fuzoku-meisai/data'
import { ResponseKoteishisanSetting, ResponseKoteishisanSettingItem } from '@/repositories/fuzoku-meisai/kaikei-kijun/data'

export interface KoteishisanRepository {
  list (): Promise<ResponseKoteishisanSetting>;

  save (param: ResponseKoteishisanSettingItem[]): Promise<void>;
}

export type PostParamItem = {
  itemName: string;
  type: KoteishisanType;
  normalSetting: Kamoku[];
  ruikeiSetting: Kamoku[];
  shoukyakuhiSetting: Kamoku[];
}

export class KoteishisanRepositoryImpl implements KoteishisanRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/koteishisan`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseKoteishisanSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseKoteishisanSettingItem[]): Promise<void> {
    const postParams: PostParamItem[] = param.map(p => {
      return {
        itemName: p.itemName,
        type: p.type,
        normalSetting: p.normalSetting.targets,
        ruikeiSetting: p.ruikeiSetting.targets,
        shoukyakuhiSetting: p.shoukyakuhiSetting.targets
      }
    })
    await this.http.post(this.baseUrl, postParams)
  }
}
